import React, { Component } from 'react'


export  default class AccountListRow extends Component{

    convertUserTyptToText(type) {
        let typeName = ''
        switch (type){
          case 'admin':
            typeName = 'ผู้ดูแลระบบ'
            break
          case 'manager':
            typeName = 'back office'
            break
          case 'sale':
            typeName = 'พนักงานขาย'
            break
          case 'technician':
            typeName = 'ช่างเทคนิค'
            break
          case 'freelance':
            typeName = 'freelance'
            break
          default :
            typeName = ''
            break
        }
        return typeName
    }

    render(){
        var branchList;

        if (this.props.branch_list.length === 0){
            branchList = <tr><td colSpan={5} className="text-center"><span className="text-danger">ไม่พบข้อมูล</span></td></tr>
        }else {

            branchList = this.props.branch_list.map((account, index) => {
                return (
                    <tr key={index}>
                        <td className="text-center">{ account.user }</td>
                        <td>
                          { account.fullname } <br/>
                          สิทธิ์ : { this.convertUserTyptToText(account.type) }
                        </td>
                        <td>{ account.email }</td>
                        <td className="text-center">{ account.mobile }</td>

                        <td className="text-right">
                            <button className={ account.type !== "admin" ? "btn btn-sm btn-danger btn-icon-width": 'hidden'}
                                    onClick={this.props.branchsCallbacks.delete.bind(null,account)}
                            >
                            <i className="fa fa-remove"></i> </button>
                            <button className="btn btn-sm btn-warning btn-icon-width"
                                    onClick={this.props.branchsCallbacks.edit.bind(null,account)}
                            >
                                <i className="fa fa-edit"></i> </button>
                        </td>
                    </tr>
                )
            });
        }

        return (
            <div className="card card-accent-info">
                <div className="card-header">
                    <strong>ข้อมูลผู้ใช้งาน</strong>
                </div>
                <div className="card-block">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th className="text-center">username</th>
                            <th>ชื่อ-นามสกุล</th>
                            <th className="text-center">อีเมล์</th>
                            <th className="text-center">เบอร์โทรศัพท์</th>
                            <th className="text-center"></th>
                        </tr>
                        </thead>
                        <tbody>
                        { branchList }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
